export enum SortByEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}
